import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {getDefaultHttpHeaders} from '../utils/http-headers.utils';
import {IUserSettings, IUserSettingsUpdate, IAdminUserListItem, UserDetailsResponse} from '@models/user.interface';
import {UserStateService} from '@services/frontend/user-state.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  private readonly BASE_URL: string = environment.apiUrl + "/users";

  constructor(private http: HttpClient,
              private userStateService: UserStateService) {}

  me(): Observable<UserDetailsResponse> {
    return this.http.get<UserDetailsResponse>(this.BASE_URL + "/me", {
      headers: getDefaultHttpHeaders().headers,
    });
  }

  listUsersForAdmin(): Observable<IAdminUserListItem[]> {
    return this.http.get<IAdminUserListItem[]>(this.BASE_URL + "/admin/list", {
      headers: getDefaultHttpHeaders().headers,
    });
  }

  getMySettings(): Observable<IUserSettings> {
    return this.http.get<IUserSettings>(this.BASE_URL + "/me/settings", {
      headers: getDefaultHttpHeaders().headers,
    });
  }

  updateMySettings(payload: IUserSettingsUpdate): Observable<IUserSettings> {
    return this.http.put<IUserSettings>(this.BASE_URL + "/me/settings", payload, {
      headers: getDefaultHttpHeaders().headers,
    });
  }

}
